import request from '@/utils/seftRequest';

// drm/ding/channel/qryOrgBindSubsSummary
export function qryOrgBindSubsServiceTypeSummary(data) {
  return request('/ding/channel/qryOrgBindSubsServiceTypeSummary', {
    method: 'POST',
    body: data,
  });
}

// drm/ding/channel/qryOrgBindSubsList
export function qryOrgBindSubsList(data) {
  return request('/ding/channel/qryOrgBindSubsList', {
    method: 'POST',
    body: data,
  });
}

// drm/ding/channel/exportOrgBindSubsList 导出
export function exportOrgBindSubsList(data) {
  return request('/ding/channel/exportOrgBindSubsList', {
    method: 'POST',
    body: data,
    responseType: 'blob',
  });
}

// drm/ding/channel/exportOrgAllBindSubsList 导出全部
export function exportOrgAllBindSubsList(data) {
  return request('/ding/channel/exportOrgAllBindSubsList', {
    method: 'POST',
    body: data,
    responseType: 'blob',
  });
}
// drm/ding/common/drmConfigItemParams
export function qryConfigParams(params) {
  return request(`/ding/common/drmConfigItemParams?paramCodes=${params.payload}`);
}

// /ding/channel/qryStatusAndExchangeCodeByCondition
export function qryStatusAndExchangeCode(data) {
  return request('/ding/channel/qryStatusAndExchangeCodeByCondition', {
    method: 'POST',
    body: data,
  });
}
